window.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // header
  const btn_two = document.getElementById('btn_header_two');
  const logo = document.querySelector('.logo-container');
  const btnTwoContainer = document.querySelector('.intro > div > div:nth-child(1)');

  const headerStartEnd = screen.width > 900 ? 'top+=110' : 'top-=50';

  const scrollTopLanding = document.querySelector('.scroll-top-container-landing');

  ScrollTrigger.create({
    trigger:'.intro',
    start:`${headerStartEnd} top`,
    end:`${headerStartEnd} top`,
    onEnter:() => {
      logo.classList.add('fixed');
      logo.appendChild(btn_two);
      scrollTopLanding.classList.add('active');
    },
    onEnterBack:() => {
      logo.classList.remove('fixed');
      btnTwoContainer.prepend(btn_two);
      scrollTopLanding.classList.remove('active');
    }
  })

  // scroll top btn

  scrollTopLanding.addEventListener('click', () => {
    gsap.to(window, {
      duration:1.2,
      ease:"power2.in",
      scrollTo:{
        y:'#MainContent'
      }
    })
  })

  const scrollTopTrigger = (window.innerWidth < 1100 || screen.width < 1100) ? '57%' : 'top';

  ScrollTrigger.create({
    trigger:'.newsletter-image',
    start:`${scrollTopTrigger} bottom`,
    end:`${scrollTopTrigger} bottom`,
    onEnter:() => {
      scrollTopLanding.classList.add('white');
    },
    onEnterBack:() => {
      scrollTopLanding.classList.remove('white');
    }
  })

  ScrollTrigger.create({
    trigger:'footer.footer',
    start:'top bottom',
    end:'top bottom',
    onEnter:() => {
      scrollTopLanding.classList.add('footer-scroll');
    },
    onEnterBack:() => {
      scrollTopLanding.classList.remove('footer-scroll');
    }
  })

  // intro

  gsap.timeline({
    scrollTrigger:{
      trigger:".image-2-lp-intro",
      start:"top 60%",
    }
  })
  .to('.intro .image-with-text__media img:nth-child(1)', {rotate:0, duration:2.5})
  .to('.image-with-text.intro img.image-3-lp-intro', {x:0, duration:3, ease:'power4.out'}, '<')
  .to('.image-with-text.intro img.image-2-lp-intro', {rotate:-135, duration:1}, '<')
  .to('.image-with-text.intro img.image-2-lp-intro', {rotate:0, duration:1}, '-=1.5')


  // taches
  var yValue = (window.innerWidth >= 1700 || screen.width >= 1700) ? '-57%' : '-78%';
  if(window.innerWidth <= 900 || screen.width <= 900){
    yValue = '-28%';
  }
  
  
   gsap.to('.image-with-text.taches img.image-2-lp-taches, .image-with-text.taches img.animate_image_part2 ', {
    y:yValue,
    scrollTrigger:{
      trigger:".taches .image-with-text__media-item",
      start:"top 55%",
      end:"55% 55%",
      scrub:1.5,
    },
    delay: 0
  })

 let cursoranimate = gsap.from('.image-with-text.taches img.image-3-lp-taches', {
    y:100,
    x:-200,
    opacity:0,
    delay:0,
    scrollTrigger:{
      trigger:".taches .image-with-text__media-item",
      start:"30% 55%",
      end:"55% 55%",
      scrub:1.5,
    }
  })

  var yValue = (window.innerWidth >= 1600 || screen.width >= 1600) ? 200 : 100;
  var start = (window.innerWidth >= 1600 || screen.width >= 1600) ? '20% 55%' : 'top 55%';
  var end = (window.innerWidth >= 1600 || screen.width >= 1600) ? 'bottom 55%' : '70% 70%';

  

  gsap.to('.image-with-text.taches img.image-4-lp-taches', {
    y:yValue,
    x:-200,
    opacity:0,
    scrollTrigger:{
      trigger:".taches .image-with-text__media-item",
      start:start,
      end:end,
      scrub:1.5,
    },
    onUpdate: getProgress, onUpdateParams: ["{self}"]
  })

  var org_image_part2_srcset = $('.image-2-lp-taches').attr('srcset');
  var ord_part2_src = $('.image-2-lp-taches').attr('src');

  function getProgress () {
    var currProgress = this.progress();
    console.log(currProgress);
    var windowOuterWidth = window.outerWidth;
    var opa = 0.62
    if(windowOuterWidth < 500 ){
      opa = 0.75
    }
    var opacity_part2 = $('.image-4-lp-taches').css('opacity');
    if($('.taches .image-4-lp-taches').isInViewport() && opacity_part2 < opa){
      var animate_image_part2_srcset = $('.animate_image_part2').attr('srcset');
      var animate_image_part2_src = $('.animate_image_part2').attr('src');
      $('.image-2-lp-taches').attr('srcset',animate_image_part2_srcset)
      $('.image-2-lp-taches').attr('src',animate_image_part2_src);
    }else{
     $('.image-2-lp-taches').attr('srcset',org_image_part2_srcset)
      $('.image-2-lp-taches').attr('src',ord_part2_src);
    } 
  }

  // const getProgress = (t) => {
  //     const currProgress = t.progress();
  //   console.log(currProgress);
  // }

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  

  $(window).scroll(function(){
    setTimeout(function(){
      var opacity = $('.image-3-lp-taches').css('opacity');
      if($('.taches .image-3-lp-taches').isInViewport() && opacity > 0.6){
        $('.after_image').css('opacity',1)
        $('.before_image').css('opacity',0)
      }else{
        $('.after_image').css('opacity',0)
        $('.before_image').css('opacity',1)
      }      
    },500)
  })

  // experts

  TLExperts = gsap.timeline({
    scrollTrigger:{
      trigger:".experts .image-with-text__media-item",
      start:"top 60%",
    },
    defaults:{
      ease:'power3.out',
      duration:2.5
    }
  })
  .fromTo('.image-with-text.experts img.image-6-lp-experts', {opacity:0, x:'-80%', y:'-80%'}, {opacity:1, x:'-50%', y:'-50%'})
  .fromTo('.image-with-text.experts img.image-3-lp-experts', {opacity:0, x:'-80%', y:'-20%'}, {opacity:1, x:'-50%', y:'-50%'}, '-=2.4')
  .fromTo('.image-with-text.experts img.image-2-lp-experts', {opacity:0, x:'-20%', y:'-80%'}, {opacity:1, x:'-50%', y:'-50%'}, '-=2.4')
  .fromTo('.image-with-text.experts img.image-4-lp-experts', {opacity:0, x:'0%', y:'-80%'}, {opacity:1, x:'-50%', y:'-50%'}, '-=2.3')
  .fromTo('.image-with-text.experts img.image-5-lp-experts', {opacity:0, x:'-20%', y:'-15%'}, {opacity:1, x:'-50%', y:'-50%'}, '-=2.3')

  ScrollTrigger.create({
    trigger:'.experts .image-with-text__media-item',
    start:'top bottom',
    end:'bottom bottom',
    onLeaveBack:() => TLExperts.reverse()
  })

  // scrollTo

  const linkScrollTo = document.querySelector('#btn_header');
  const linkScrollToTwo = document.querySelector('#btn_header_two');
  linkScrollTo.addEventListener('click', (e) => {
      e.preventDefault();
      gsap.to(window, {duration:1.2, ease:"power2.in", scrollTo:{y:'.newsletter-content'}});
  })
  linkScrollToTwo.addEventListener('click', (e) => {
      e.preventDefault();
      gsap.to(window, {duration:1.2, ease:"power2.in", scrollTo:{y:'.newsletter-content'}});
  })

  // form newsletter

  const inputEmail = document.querySelector('#form_newsletter input[name="email"]');
  const newsletterContainer = document.querySelector('.newsletter-content');
  const errorEmailNewsletter = document.querySelector('.error-email-newsletter');
  const formNewsletter = document.querySelector('#form_newsletter');

  let formValid = true;
  let firstErrorDisplayed = false;

  inputEmail.addEventListener('input', () => {
    if(firstErrorDisplayed){
      checkEmail();
    }
  });
  inputEmail.addEventListener('blur', checkEmail);

  formNewsletter.addEventListener('submit', function(e){
    e.preventDefault();
    var email = $('#form_newsletter #email').val();

    checkEmail();
    
    if(formValid){
      const href = atob(formId);
      
      
      $.ajax({
          type: "POST",
          dataType: "json",
          url: href,
          data: $(this).serialize(),
          success: function(response){
              if(response.status == "success"){
                newsletterContainer.classList.add('success');
              }
          }
      });
    }
    else{
    
    }
  })

  function checkEmail(){
    const regexFormatEmailnewsletter = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(inputEmail.value.length === 0){
      errorEmailNewsletter.innerHTML = errorEmailNewsletter.dataset.errorEmpty;
      newsletterContainer.classList.add('error');
      formValid = false;
      firstErrorDisplayed = true;
    }
    else if(!inputEmail.value.match(regexFormatEmailnewsletter)){
      errorEmailNewsletter.innerHTML = errorEmailNewsletter.dataset.errorFormat;
      newsletterContainer.classList.add('error');
      formValid = false;
      firstErrorDisplayed = true;
    }
    else{
      formValid = true;
      newsletterContainer.classList.remove('error');
      errorEmailNewsletter.innerHTML = "";
    }

  }

  // if(Active){
  //   $("#instagram").click(function () {
  //     ('event', 'landing_instagram_btn_click');
  //   });
  //   $("#fb").click(function () {
  //       ('event', 'landing_facebook_btn_click');
  //   });
  // }
})